module.exports = __webpack_public_path__ + "462f42c768339021e76225e003d5e029.svg";